export enum PremiosTipoEnum { GIFTCARD, SUBSCRIPTION, PRODUCT, DRAW, CREDIT_RECHARGE }

const idsPremiosTipo = new Map<PremiosTipoEnum, string>();
idsPremiosTipo.set(PremiosTipoEnum.GIFTCARD, "GIFTCARD");
idsPremiosTipo.set(PremiosTipoEnum.SUBSCRIPTION, "SUBSCRIPTION");
idsPremiosTipo.set(PremiosTipoEnum.PRODUCT, "PRODUCT");
idsPremiosTipo.set(PremiosTipoEnum.DRAW, "DRAW");
idsPremiosTipo.set(PremiosTipoEnum.CREDIT_RECHARGE, "CREDIT_RECHARGE");

const nombresPremiosTipo = new Map<PremiosTipoEnum, string>();

nombresPremiosTipo.set(PremiosTipoEnum.GIFTCARD, "Gift card");
nombresPremiosTipo.set(PremiosTipoEnum.SUBSCRIPTION, "Suscripción");
nombresPremiosTipo.set(PremiosTipoEnum.PRODUCT, "Producto");
nombresPremiosTipo.set(PremiosTipoEnum.DRAW, "Draw");
nombresPremiosTipo.set(PremiosTipoEnum.CREDIT_RECHARGE, "Recarga telefónica");

export const obtenerIdPremioTipo: (premioTipo: PremiosTipoEnum) => string =
    premioTipo => idsPremiosTipo.get(premioTipo) ?? "";
export const obtenerNombrePremioTipo: (premioTipo: PremiosTipoEnum) => string =
    premioTipo => nombresPremiosTipo.get(premioTipo) ?? "";

export const obtenerNombresPremioTipo: () => Array<[PremiosTipoEnum, string]> =
    () => Array.from(nombresPremiosTipo.entries());
